import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/lib/ist-locale";  // Phase 2.46.13 — force Asia/Kolkata (IST) globally
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
